<template>
  <section class="_popup-wrapper">
    <transition name="popup-hide" @after-leave="$emit('popup-hide')">
      <div v-show="show" class="_popup-wrapper-inner">
        <slot />
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
};
</script>

<style scoped>
._popup-wrapper {
  position: absolute;
  margin: 0;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.8);
  overflow: hidden;
}
._popup-wrapper-inner {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.popup-hide-enter-active {
  animation: fadeIn 0.1s ease-in;
}
.popup-hide-leave-active {
  animation: fadeIn 0.1s ease-in reverse;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
